import z from "zod";
import { FILE_COLLECTION_TABLES, isFileCollectionKey } from "../../../types/files";

/**
 * The address of one collection's attachments: which junction table, which column, which parent.
 *
 * Both halves are pinned. The table has to be one the registry declares, and the column has to be
 * one that collection is addressable by — a bare string there would let a caller choose which
 * column of the row the query matches on.
 */
export const getForeignFilesSchema = z
	.object({
		tableName: z.enum(FILE_COLLECTION_TABLES),
		key: z.string(),
		identifier: z.uuid(),
	})
	.refine(({ tableName, key }) => isFileCollectionKey(tableName, key), {
		message: "key is not a foreign key column of this collection",
		path: ["key"],
	});
